export default "__VITE_ASSET__9b0ac87d__"